import { render, staticRenderFns } from "./StartupSearch.vue?vue&type=template&id=398ed70e&scoped=true"
import script from "./StartupSearch.vue?vue&type=script&lang=js"
export * from "./StartupSearch.vue?vue&type=script&lang=js"
import style0 from "./StartupSearch.vue?vue&type=style&index=0&id=398ed70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ed70e",
  null
  
)

export default component.exports